import React, {Component} from 'react';
import {connect} from "react-redux";
import {Link, browserHistory} from "react-router";
import {AddToBasketModal} from "../../../common/elements";
import purchaseActions from '../../../../actions/transactions/purchases';
import basketActions from '../../../../actions/transactions/basket';
import {NetworkHelpers as Network, BasketCheckHelper, requestHelpers } from '../../../../helpers';

import Prismic from 'prismic-javascript'
import {PrismicConfig} from '../../../../helpers/prismicHelpers/PrismicAPI'
import {LanguagePrismicHelper} from '../../../../helpers/prismicHelpers/PrismicHelpers'
import {
    prismicSliceHelper,
    prismicSliceContentRelationship
} from '../../../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers'
import {sliceComponentsHelper} from '../../../../helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers'
import Loader from '../../../common/elements/Loader';
import {siteOfOriginHelper} from '../../../../helpers/genericHelpers';
import BreakBanner from "../../../dashboardNew/components/BreakBanner";

class CvWritingPage extends Component {

    state = {
        slices: null,
        success: false,
        error : false
    }

    componentWillMount() {
        const {getProducts} = this.props;
        getProducts();
        const siteOfOrigin = siteOfOriginHelper();
        if (siteOfOrigin === 'us') {
            browserHistory.push('/');
        }
    }

    async componentDidMount() {

        //prismic
        const prismicConnection = await Prismic.api(PrismicConfig.apiEndpoint, {accessToken: PrismicConfig.apiAccessTokes});
        const json = await prismicConnection.query(Prismic.Predicates.at('my.ecom-page.uid', 'writing-services'), LanguagePrismicHelper());
        let {slices} = prismicSliceHelper(json);
        slices = (slices && slices.length) ? await prismicSliceContentRelationship(slices, prismicConnection) : null;
        this.setState({slices});
    }

    enquireResponseMessage(){
        if( this.state.success ){ return <p className="body-copy">Thank you for your enquiry. Someone from our CV services team will be in touch.</p> }
        if( this.state.error ){ return <p className="body-copy error">Something went wrong. Please refresh your page and try again.</p> }
    }

    enquireHandler( evt ){
        evt.preventDefault();

        this.setState({ loading : true });
        requestHelpers
            .authenticatedPostRequest( '/communications/enquire-writing-services', { person_id : window.localStorage.getItem( 'person_id' ), page : 'CvWritingPage' } )
            .then( res => this.setState({ success : true, loading : false }) )
            .catch( err => {
                this.setState({ error : true, loading : false });
                console.error('err : ', err);
            });

    }

    render() {

        const image = '/images/bg-cvwriting.jpg';
        const {slices} = this.state;
        const {allProducts, addProductToBasket, basket} = this.props;
        const products = BasketCheckHelper.checkProductsInBasket(allProducts, basket),
            cvServiceProduct = products.filter(product => parseInt(product.id, 10) === 27)[0];

        if (!products) return <Loader/>;

        return (
            <div className="container-fluid cv-page">
                {slices && sliceComponentsHelper(slices)}
                {
                    cvServiceProduct ?
                        <AddToBasketModal product={cvServiceProduct} addToBasket={addProductToBasket}/> : null
                }
                <div className="container theme-page-content-wrapper">
                    <div className="row">
                        <div className="col-12 heading-section no-margin">
                            <p className="body-copy">Without the right kind of guidance when creating a CV,
                                professionals run the risk of making elementary mistakes that can undermine
                                applications. Not only that, they often fail to utilise the tools and techniques
                                that can make them stand out from the crowd through the provision of a CV that
                                hits the mark. Research shows that those in a more senior position are the least
                                capable and the least confident when it comes to writing a powerful CV that will
                                have the right kind of impact. <br/> <br/> Our experienced team at In Touch Networks, has created a powerful online audit process that provides guidance, advice and critique to help individuals create a document that reflects who they are and what they have achieved.</p>
                        </div>
                        <div className="col-12">
                            <ul className="writing-list">
                                <li className="writing-item">
                                    <img src="/images/icons-new/CVicon1.svg" alt=""
                                         className="writing-item-img"/>
                                    Maximise the impact of your CV and job applications
                                </li>
                                <li className="writing-item">
                                    <img src="/images/icons-new/CVicon2.svg" alt=""
                                         className="writing-item-img"/>
                                    Specialist, objective advice to help you sell yourself to employers
                                </li>
                                <li className="writing-item">
                                    <img src="/images/icons-new/CVicon3.svg" alt=""
                                         className="writing-item-img"/>
                                    Developed by expert recruiters and HR professionals
                                </li>
                                <li className="writing-item">
                                    <img src="/images/icons-new/CVicon4.svg" alt=""
                                         className="writing-item-img"/>
                                    Create authentic collateral that accurately reflects your skills
                                </li>
                                <li className="writing-item">
                                    <img src="/images/icons-new/CVicon5.svg" alt=""
                                         className="writing-item-img"/>
                                    Comprehensive video guides and workbooks for additional support
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 inner-image" data-aos>
                        <div className="image" style={{backgroundImage: `url(${image})`}}></div>
                        <div className="container">
                            <div className="inner-content">
                                <h3 className="heading-main">Make the right impression.</h3>
                                <p className="body-copy">Making the right impression with your CV is essential when
                                    applying for any role, even more so when the position is at a senior or management
                                    level.</p>
                                <p className="body-copy">Our award-winning team at In Touch Networks
                                    has created a powerful audit process that provides
                                    guidance, advice and critique to help professionals create a
                                    CV that successfully showcases who they are to recruiters
                                    and employers, providing the best chance of opening the door
                                    to interview.</p>
                                <p className="body-copy">Employers tell us what they’re looking for
                                    when it comes to job applications, and having already helped
                                    thousands of elite professionals land their ideal role, we
                                    know how your skills and expertise should be presented to
                                    make a positive impact.</p>
                                <p className="body-copy">This exclusive service is available at an
                                    additional cost.</p>
                                <p className="body-copy">Find out how our services have helped
                                    members to secure fantastic roles.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12 cv-page-body">
                            <p className="body-copy">Rather than handing responsibility for the creation of such an
                                important document to one of the many CV bureaus, In Touch CV works in a way
                                that allows for personal authenticity and individuality, creating a document
                                that uses their language with a personal focus that makes the right impact.</p>
                            <p className="body-copy">These resources include hard copy published materials, PDFs and
                                videos combined with the attention of one of our experienced staff. We work
                                closely with every individual, providing the experienced and objective eye to
                                create collateral - including covering letters for every occasion - that will
                                lead to career success.</p>
                        </div>
                        <div className="col-12 cv-page-purchase">                            
                            <a
                                className="cv-button purchase-button"
                                href="https://intouchnetworks.com/en-gb/payment?product_id=28&stripe_id=CVSERVICE&post_id=4222"
                                target="_blank"
                            >
                                <i className="fa fa-shopping-cart button-icon"/>
                                <span className="button-text">Buy now</span>
                            </a>
                        </div>
                        <div className="col-12">
                            <ul className="writing-list">
                                <li className="writing-item">
                                    <img src="/images/icons-new/CVicon1bottom.svg" alt=""
                                         className="writing-item-img"/>
                                    In-Depth Video Tutorials
                                </li>
                                <li className="writing-item">
                                    <img src="/images/icons-new/CVicon2bottom.svg" alt=""
                                         className="writing-item-img"/>
                                    Step-by-Step Guidance
                                </li>
                                <li className="writing-item">
                                    <img src="/images/icons-new/CVicon3bottom.svg" alt=""
                                         className="writing-item-img"/>
                                    Expert Advice &amp; Critique
                                </li>
                                <li className="writing-item">
                                    <img src="/images/icons-new/CVicon4bottom.svg" alt=""
                                         className="writing-item-img"/>
                                    Journal Workbook Assistance
                                </li>
                                <li className="writing-item">
                                    <img src="/images/icons-new/CVicon5bottom.svg" alt=""
                                         className="writing-item-img"/>
                                    Dedicated Account Management
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <BreakBanner
                    title="How we help"
                    copy="Find out how our services have helped members to secure fantastic roles"
                    cta_link="/testimonials"
                    cta_text="View testimonials"
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        allProducts: state.transactions.products,
        basket: state.transactions.basket,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getProducts: () => dispatch(purchaseActions.getProducts()),
        addProductToBasket: productId => dispatch(basketActions.addProductToBasket(productId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CvWritingPage);




// WEBPACK FOOTER //
// src/client/components/site/features/cvwriting/CvWritingPage.js